<template>
  <div class="ourNews">
    <BreadsCrums page="ourNews" previous="home" />
    <Articles
      :articles="ourNews"
      :pagination="pagination"
      type="news"
      paginationType="posts"
      v-if="!loading"
    />
    <Loader v-else />
  </div>
</template>

<script>
// @ is an alias to /src
import Axios from 'axios';
import APPURL from '../constant';
export default {
  watch: {
    $route() {
      this.getNews();
    }
  },
  created() {
    document.title = this.$i18n.t('navBar.ourNews');
  },
  mounted() {
    this.getNews();
    this.getTags();
  },
  data() {
    return {
      ourNews: {},
      categories: {},
      tags: {},
      pagination: {},
      loading: true
    };
  },
  methods: {
    getNextArticles() {
      this.getArticles(this.posts.next_page_url);
    },
    getNews(url = APPURL.LINK + 'posts/' + this.$i18n.locale + '/1/18') {
      Axios.get(url).then(response => {
        this.ourNews = response.data.data.results.posts;
        this.categories = response.data.data.results.categories;
        this.pagination = response.data.data.pagination;
        this.loading = false;
        //console.log(this.pagination);
      });
    },
    getTags(url = APPURL.LINK + 'tags/') {
      Axios.get(url).then(response => {
        this.tags = response.data.data.results;
        // console.log(this.tags);
      });
    }
  },
  name: 'home',
  components: {}
};
</script>
